import axios from 'axios';
import storage from 'helpers/storage';
import { notification } from 'antd';
import api from 'config';
import errorHandler from './errorHandler';
import successHandler from './successHandler';
import * as CAPTAIN_PAYMENT from './captainpayment';
import { installAxiosHeaderValidation } from 'helpers/axiosHeaderSecurity';
import { auth as authClient } from 'helpers/auth';

const { authAPI, companyAPI } = api.config;
const timeout = 30000;
export const source = axios.CancelToken.source();

export const AUTH_API = axios.create({
  baseURL: authAPI,
  // withCredentials: true,
  responseType: 'json',
  headers: {
    'content-type': 'application/json;charset=UTF-8'
  }
  // transformRequest: [
  //   (data, headers) => {
  //     console.log(data, '################# 1');
  //     // Do whatever you want to transform the data
  //     return data;
  //   }
  // ]
});
installAxiosHeaderValidation(AUTH_API);

export const COMPANY_API = axios.create({
  baseURL: companyAPI,
  // withCredentials: true,
  // mode: 'no-cors',
  // credentials: 'same-origin',
  // crossdomain: true,

  responseType: 'json',
  headers: {
    'content-type': 'application/json;charset=UTF-8'
  }
});
installAxiosHeaderValidation(COMPANY_API);

export const COMPANY_API_NO_RESULT_RESPONSE = axios.create({
  baseURL: companyAPI,
  responseType: 'json',
  headers: {
    'content-type': 'application/json;charset=UTF-8'
  }
});
installAxiosHeaderValidation(COMPANY_API_NO_RESULT_RESPONSE);

const interceptor = function(config) {
  const { url, headers } = config;
  const info = storage.get('info');
  const company = storage.get('company');
  let isMe = false;

  if (url === `${companyAPI}/addons/v1/me`) {
    isMe = true;
  }
  if (!isMe && company && company.user && company.id) {
    headers.common['x-userid'] = company.user && company.user.id;
    headers.common['x-comid'] = company.id;
    if (info) {
      headers.common['x-corp'] = JSON.stringify(info.auth);
    }
  }

  return config;
};

export const onfulfilled = async function(response) {
  // 응답 데이터를 가공
  // ...
  await successHandler(response);
  return response;
};

export const onRejected = function(error) {
  // // 오류 응답을 처리
  // // ...
  if (error.response) {
    const {
      response: { status, data }
    } = error;
    errorHandler(error);
  }
  // if(status > 299){
  //   const { message:description , title:message} = data;

  //   // notification['error']({ message, description,});
  // }
  return Promise.reject(error);
};

COMPANY_API.interceptors.request.use(interceptor, function(error) {
  return Promise.reject(error);
});
COMPANY_API_NO_RESULT_RESPONSE.interceptors.request.use(interceptor, function(error) {
  return Promise.reject(error);
});
authClient.installInterceptor(COMPANY_API);
authClient.installInterceptor(COMPANY_API_NO_RESULT_RESPONSE);

COMPANY_API.interceptors.response.use(onfulfilled, onRejected);

COMPANY_API_NO_RESULT_RESPONSE.interceptors.response.use((response) => response, onRejected);

export { CAPTAIN_PAYMENT };
